import {Routes} from '@angular/router';
import {headerRoute, footerRoute} from './';
import {sidebarRoute} from './sidebar/sidebar.route';

export const layoutRoutes: Routes = [
  headerRoute,
  footerRoute,
  sidebarRoute
];



// WEBPACK FOOTER //
// ./src/app/layouts/layout.route.ts